export const css = {
    root: '_2K3qmaw5',
    close: '_2cuzd0vc',
    indicator: '_3n3KvO_J',
    tabButtons: '_6WGwqWSs',
    tabButton: '_1t6vbh0J',
    disabledTabButton: '_36PfMLBL',
    activeTabButton: 'D9iqM0nV',
    closeable: '_300NbKfH',
    tab: '_3G0Hzk3A',
    alignLeft: '_1loT82zN',
    alignRight: '_1452YXvi',
    tabs: '_1trvSfBN',
    alignBottom: '_1ZcYAXhr',
    indicatorActive: '_1BPDP5LS',
    indicatorContent: '_3Lwtqglk',
    tabButtonContent: '_1e-j5G1j',
    ' _key': 'certwise-theme/certwise/base-widgets/tab-container'
};
export default css;
